import router from '@/router'
import use124Actions from '@/composables/actions/use124Actions'
import use212Actions from '@/composables/actions/use212Actions'
import use407Actions from '@/composables/actions/use407Actions'
import useIssueVisaActions from '@/composables/actions/useIssueVisaActions'
import use873Actions from '@/composables/actions/use873Actions'
import use663Actions from '@/composables/actions/use663Actions'
import use140Actions from '@/composables/actions/use140Actions'
import use375Actions from '@/composables/actions/use375Actions'
export default function (actionName, actionParams) {
  const serviceId = +router.currentRoute.value.params.serviceId

  if (serviceId === 124) {
    use124Actions(actionName, actionParams)
  }
  if ([212, 495].includes(serviceId)) {
    use212Actions(actionName, actionParams)
  }
  if (serviceId === 407) {
    use407Actions(actionName, actionParams)
  }

  if (serviceId === 140) {
    use140Actions(actionName, actionParams)
  }

  if (serviceId === 375) {
    use375Actions(actionName, actionParams)
  }

  if (serviceId === 663) {
    use663Actions(actionName, actionParams)
  }
  if (serviceId === 873) {
    use873Actions(actionName, actionParams)
  }
  if ([432, 763, 783, 784, 939, 941, 942, 944, 945, 946, 962].includes(serviceId)) {
    useIssueVisaActions()[actionName]
  }
  if (
    [
      387, 983, 24, 36, 50, 69, 385, 569, 632, 765, 1038, 978, 977, 1123, 1090, 1042, 640, 406, 385,
      69, 57, 36, 24, 436
    ].includes(serviceId)
  ) {
    useIssueVisaActions()[actionName]()
  }
}
